import React from "react";

const defaultenvclearanceData = [
  {
    location: "",
    operation: "",
    compliance: "",
  },
];

const EnvironmentalClearanceTable = ({
  envclearanceData,
  setEnvClearanceData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...envclearanceData];
    updated[index][field] = value;
    setEnvClearanceData(updated);
  };

  const addRow = () => {
    setEnvClearanceData([
      ...envclearanceData,
      {
        location: "",
        operation: "",
        compliance: "",
      },
    ]);
  };

  const removeRow = () => {
    if (envclearanceData.length > 1) {
      setEnvClearanceData(envclearanceData.slice(0, -1));
    }
  };

  return (
    <>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#d3c9ce" }}>
              <th style={headerCell}>S. No</th>
              <th style={headerCell}>Location of operations / offices</th>
              <th style={headerCell}>Type of operations</th>
              <th style={headerCell}>
                Whether the conditions of environmental approval/clearance are
                being
                <br />
                complied with? (Yes/No)
                <br />
                If no, the reasons thereof and <br />
                Corrective action taken, if any.
              </th>
            </tr>
          </thead>
          <tbody>
            {envclearanceData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{index + 1}.</td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Location of operations / offices"
                    value={row.location}
                    onChange={(e) =>
                      handleChange(index, "location", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Type of operations"
                    value={row.operation}
                    onChange={(e) =>
                      handleChange(index, "operation", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.compliance}
                    onChange={(e) =>
                      handleChange(index, "compliance", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </>
  );
};

// Styles
const headerCell = {
  border: "1px solid #000",
  padding: "10px",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#d3c9ce",
  fontSize: "14px",
};

const cell = {
  border: "1px solid #ccc",
  padding: "15px",
  textAlign: "left",
};

const inputStyle = {
  width: "100%",
  padding: "15px",
  borderRadius: "4px",
  border: "1px solid gray",
  fontSize: "14px",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default EnvironmentalClearanceTable;
